import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Create_Material } from '../../../actions/curriculums/materials';
import { BoxLoading } from 'react-loadingg';
import { HomePage } from '../../../translations/trans';

function AddMaterial() {
  const [showModal, setShowModal] = useState(false);
  const [materialName, setMaterialName] = useState('');
  const [materialCode, setMaterialCode] = useState('');
  const [alertVariant, setAlertVariant] = useState('danger'); // State for alert variant
  const [alertMessage, setAlertMessage] = useState(null); // State for alert message
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAlertMessage(null); // Clear alert message when closing modal
  };

  const handleCreateMaterial = async () => {
    try {
      setLoading(true);

      // Dispatch the create material action (await if asynchronous)
      const res = await dispatch(Create_Material({ name: materialName, code: materialCode }));

      // Optionally, you can reset the input fields after creating the material
      setMaterialName('');
      setMaterialCode('');

      // Determine the alert variant based on res.data.case
      setAlertVariant(res.data.case ? 'success' : 'danger');

      // Set the alert message
      setAlertMessage(res.data.message);
    } catch (err) {
      console.error(err.message);

      // Handle errors or provide user feedback as needed
      setAlertVariant('danger');
      setAlertMessage('Error creating material. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  const { lang, dir } = useSelector(({ language }) => {
    return { lang: language.lang, dir: language.dir };
  });

  return (
    <div>
      <h2>{HomePage.addMaterial[lang]}</h2>
      <Button variant="primary" onClick={handleOpenModal}>
        {HomePage.add[lang]}
      </Button>

      <Modal show={showModal} onHide={handleCloseModal} dir={dir}>
        <Modal.Header closeButton>
          <Modal.Title>{HomePage.addMaterial[lang]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {alertMessage && (
            <Alert variant={alertVariant} onClose={() => setAlertMessage(null)} dismissible>
              {alertMessage}
            </Alert>
          )}

          <Form>
            <Form.Group controlId="formMaterialName">
              <Form.Label>{HomePage.MaterialName[lang]}:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter material name"
                value={materialName}
                onChange={(e) => setMaterialName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formMaterialCode">
              <Form.Label>{HomePage.materialCode[lang]}:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter material code"
                value={materialCode}
                onChange={(e) => setMaterialCode(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {!loading ? (
            <>
              <Button variant="secondary" onClick={handleCloseModal}>
                {HomePage.cancel[lang]}
              </Button>
              <Button variant="primary" onClick={handleCreateMaterial}>
                {HomePage.CreateMaterial[lang]}
              </Button>
            </>
          ) : (
            <BoxLoading />
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AddMaterial;
